<div class="mep-info-dialog">
	<div class="mep-info-dialog-content" mat-dialog-content>
		<div>
			<mat-icon class="mep-icon-info-dialog">info</mat-icon>
		</div>
		<div class="mep-text-big-bold">
			{{ "mep.components.favorite-resource-request-dialog.add-favorite-to-rr" | translate }}
		</div>
	</div>

	<div class="comment-container">
		<mat-form-field class="w-100 h-100">
			<textarea
				matInput
				placeholder="{{ 'mep.components.favorite-resource-request-dialog.comment-placeholder' | translate }}"
				[(ngModel)]="comment"
				[maxlength]="255"
			></textarea>
		</mat-form-field>
	</div>

	<div class="mep-dialog-actions">
		<button class="mep-btn-dialog-secondary" (click)="onCancel()">
			{{ "mep.components.general.cancel" | translate }}
		</button>
		<button class="mep-btn-dialog-primary" (click)="onSave()">
			{{ "mep.components.general.confirm" | translate }}
		</button>
	</div>
</div>
